export function SidebarDivider() {
  return (
    <div className="px-4">
      <div className="h-px bg-white/15" />
    </div>
  );
}
